import { api } from "./api";

export interface ClientInfo {
  id: string;
  org_id: string;
  name: string;
  status: string;
  capabilities: string[];
  last_heartbeat: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
}

export interface ClientCreateResult {
  client: ClientInfo;
  api_key: string;
}

export const clientService = {
  list: (orgId: string) =>
    api.get<ClientInfo[]>(`/orgs/${orgId}/clients`),

  get: (orgId: string, clientId: string) =>
    api.get<ClientInfo>(`/orgs/${orgId}/clients/${clientId}`),

  create: (orgId: string, name: string) =>
    api.post<ClientCreateResult>(`/orgs/${orgId}/clients`, { name }),

  update: (orgId: string, clientId: string, name: string) =>
    api.put<ClientInfo>(`/orgs/${orgId}/clients/${clientId}`, { name }),

  delete: (orgId: string, clientId: string) =>
    api.delete(`/orgs/${orgId}/clients/${clientId}`),

  regenerateKey: (orgId: string, clientId: string) =>
    api.post<ClientCreateResult>(`/orgs/${orgId}/clients/${clientId}/regenerate-key`),
};
